"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateOrThrow = validateOrThrow;
exports.validateSafe = validateSafe;
exports.parseBodyWithSchema = parseBodyWithSchema;
exports.parseQueryWithSchema = parseQueryWithSchema;
exports.parsePathWithSchema = parsePathWithSchema;
exports.validatePartial = validatePartial;
const zod_1 = require("zod");
const errors_1 = require("./errors");
function validateOrThrow(schema, data) {
    const result = schema.safeParse(data);
    if (!result.success) {
        throw new errors_1.ValidationError(result.error);
    }
    return result.data;
}
function validateSafe(schema, data) {
    const result = schema.safeParse(data);
    if (!result.success) {
        return { success: false, error: new errors_1.ValidationError(result.error) };
    }
    return { success: true, data: result.data };
}
function parseBodyWithSchema(schema, event) {
    if (!event.body) {
        throw new errors_1.ValidationError(new zod_1.z.ZodError([
            { code: 'custom', message: 'Request body is required', path: ['body'] },
        ]));
    }
    const parsed = JSON.parse(event.body);
    return validateOrThrow(schema, parsed);
}
function parseQueryWithSchema(schema, event) {
    return validateOrThrow(schema, event.queryStringParameters || {});
}
function parsePathWithSchema(schema, event) {
    return validateOrThrow(schema, event.pathParameters || {});
}
function validatePartial(schema, data) {
    return validateOrThrow(schema.partial(), data);
}
//# sourceMappingURL=validate.js.map